import * as React from "react";
const SvgSpendesk = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 298.5 247.7",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M166.3 111.4c-1.3-1.3-1.3-3.5 0-4.8l24.8-24.8c1.3-1.3 3.5-1.3 4.8 0l50.1 50.1c1.7 1.8 2.7 4.1 2.7 6.7 0 2.7-1.1 5.1-2.8 6.8l-51.4 51.4c-.6.6-1.5 1-2.4 1h-49.6c-1.9 0-3.4-1.5-3.4-3.4 0-1 .4-1.9 1.1-2.5l51-51c.6-.6 1-1.5 1-2.4s-.3-1.7-1-2.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M132.2 136.3c1.3 1.3 1.3 3.5 0 4.8l-24.8 24.8c-1.3 1.3-3.5 1.3-4.8 0l-50.1-50.1c-1.7-1.8-2.7-4.1-2.7-6.7 0-2.7 1.1-5.1 2.8-6.8L104 50.8c.6-.6 1.5-1 2.4-1H156c1.9 0 3.4 1.5 3.4 3.4 0 1-.4 1.9-1.1 2.5l-51 51c-.6.7-1 1.5-1 2.4s.3 1.7 1 2.4c0 0 24.9 24.9 24.9 24.9"
}));
export default SvgSpendesk;
//# sourceMappingURL=Spendesk.js.map